import { render, staticRenderFns } from "./textDrag_echo.vue?vue&type=template&id=73e08f54&scoped=true&"
import script from "./textDrag_echo.vue?vue&type=script&lang=js&"
export * from "./textDrag_echo.vue?vue&type=script&lang=js&"
import style0 from "./textDrag_echo.vue?vue&type=style&index=0&id=73e08f54&scoped=true&lang=scss&"
import style1 from "./textDrag_echo.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e08f54",
  null
  
)

export default component.exports